import { render, staticRenderFns } from "./SupportButton.vue?vue&type=template&id=f7202088"
import script from "./SupportButton.vue?vue&type=script&lang=js"
export * from "./SupportButton.vue?vue&type=script&lang=js"
import style0 from "./SupportButton.vue?vue&type=style&index=0&id=f7202088&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports